//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useState } from 'react';
import { Menu, MenuItem, Button } from '@mui/material';
import PathLink from './PathLink';
import { selectCurrentPath } from '@/redux/selectors/fileManagerSelectors';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

type GroupedPathsProps = {
  onClick: (index: number) => void;
};

const GroupedPaths = ({ onClick }: GroupedPathsProps) => {
  const currentPath: any[] = useAppSelector(selectCurrentPath) || [];
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event: any) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const groupedPaths = currentPath.slice(1, -1);

  if (!currentPath || !groupedPaths) return null;
  return (
    <>
      <StyledButton aria-controls="grouped-paths-menu" aria-haspopup="true" onClick={handleClick as any} color="primary" variant="text">
        ...
      </StyledButton>
      <StyledMenu
        id="grouped-paths-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {groupedPaths.map((path, index) => (
          <StyledMenuItem key={`${path}-${index}`} onClick={() => onClick(index + 1)}>
            <PathLink stage={path} index={index} onClick={() => {}} />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

const StyledMenu = styled(Menu)`
  max-height: 28.5rem;
`;

const StyledButton = styled(Button)`
  margin: ${({ theme }) => theme.spacing(-1)};
  font-size: 1.7rem;
  min-width: 10px;
`;

const StyledMenuItem = styled(MenuItem)`
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  color: ${({ theme }) => theme.palette.text.primary};
  min-width: 200px;
  display: flex;
  justify-content: space-between;
`;

export default GroupedPaths;
